import { useAtomValue } from 'jotai'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Helmet } from 'react-helmet-async'

import CustomPaper from '@/components/custom-paper'
import LargeContainerMap from '@/components/large-container-map'
import LargeContainerMapInfo from '@/components/large-container-map/info'
import { selectedMunicipalityIdAtom } from '@/state'

function LargeContainerMapView() {

    const title = 'Veřejná svozová místa'

    const municipalityId = useAtomValue(selectedMunicipalityIdAtom)

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <CustomPaper>
                <Box position="relative">
                    <Typography variant="h2" component="h1" mb={1.5}>
                        {title}
                    </Typography>
                    {municipalityId ?
                        <>
                            <LargeContainerMapInfo />
                            <LargeContainerMap />
                        </>
                        :
                        <Box>
                            Vyberte prosím konkrétní obec výše.
                        </Box>
                    }
                    
                </Box>
            </CustomPaper>
        </>
    )
}

export default LargeContainerMapView
